import React, { Component } from 'react';
import Routes from './routes';
import AppFooter from './components/AppFooter';
import UnsupportedShard from './pages/UnsupportedShard';
import './App.css';
import './myisp-theme.css';
import statsTracker from './utils/stats_tracker';
import { withRouter } from 'react-router-dom';
import i18n from './i18n';

const shardEnabled = process.env.SHARD_ENABLED;

class TrackingWrapper extends Component {
  constructor(props) {
    super(props);

    this.props.history.listen(this.onPageChange.bind(this));
  }

  onPageChange(location, action) {
    statsTracker.trackPageView(`/${i18n.currentLanguage()}${location.pathname}`);
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

TrackingWrapper = withRouter(TrackingWrapper);

class App extends Component {
  componentDidMount() {
    window.location.hash = window.decodeURIComponent(window.location.hash);

    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split('#');
      if (hashParts.length > 1) {
        const hash = hashParts.slice(-1)[0];
        document.querySelector(`#${hash}`).scrollIntoView();
      }
    };

    //TODO: Find a better way to trigger this, but if we fire it immediately the page
    //dimensions aren't set, and it doesn't scroll completely down the page.
    setTimeout(() => {
      scrollToAnchor();
    }, 500);
    
    window.onhashchange = scrollToAnchor;
  }

  render() {
    return (
      <div>
        { shardEnabled ? 
          <Routes><TrackingWrapper /></Routes> :
          <UnsupportedShard />
        }
        <AppFooter />
      </div>
    );
  }
}

export default App;
;


// WEBPACK FOOTER //
// ./src/App.js